(function () {
  let customerChoice = 'one-time';
  let selectedSellingPlan = '5233049824';

  const ONETIME_SELECTOR = 'input[type="radio"][data-type="one-time"][name="selling_plan"]';
  const SUBSCRIPTION_INPUTS = 'input.subscription-input[name="selling_plan"]';
  const SELLING_PLAN_SELECT = '#selling_plan_select';
  const VARIANT_RADIOS = 'input[data-single-option-selector][data-index="option1"]';

  function restoreChoice() {
    if (customerChoice === 'one-time') {
      const onetimeRadio = document.querySelector(ONETIME_SELECTOR);
      if (onetimeRadio && !onetimeRadio.checked) {
        onetimeRadio.checked = true;
        onetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        onetimeRadio.dispatchEvent(new Event('click', { bubbles: true }));
      }
      return true;
    }

    // For subscription, we need the radio AND the select to exist
    const subRadio = document.querySelector(
      SUBSCRIPTION_INPUTS + '[value="' + selectedSellingPlan + '"]'
    );
    const select = document.querySelector(SELLING_PLAN_SELECT);
    const onetimeRadio = document.querySelector(ONETIME_SELECTOR);

    if (!subRadio || !select || !onetimeRadio) return false; // not ready yet

    // Uncheck one-time first
    if (onetimeRadio.checked) {
      onetimeRadio.checked = false;
    }

    // Check the subscription radio
    subRadio.checked = true;
    subRadio.dispatchEvent(new Event('change', { bubbles: true }));
    subRadio.dispatchEvent(new Event('click', { bubbles: true }));

    // Sync the frequency dropdown
    if (select.value !== selectedSellingPlan) {
      select.value = selectedSellingPlan;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Simulate clicking the subscription toggle label to trigger Skio's own logic
    const subToggle = document.querySelector('.subscription-toggle');
    if (subToggle) {
      subToggle.click();
    }

    return true;
  }

  // Retry restore multiple times to handle Skio's async re-render
  function restoreWithRetries() {
    let attempts = 0;
    const maxAttempts = 15;

    function tryRestore() {
      attempts++;
      const success = restoreChoice();

      if (!success && attempts < maxAttempts) {
        setTimeout(tryRestore, 200);
      } else if (success && attempts < 5) {
        // Even after success, Skio might overwrite — re-apply a few more times
        setTimeout(restoreChoice, 300);
        setTimeout(restoreChoice, 600);
        setTimeout(restoreChoice, 1000);
      }
    }

    tryRestore();
  }

  // Track customer intent
  document.addEventListener('change', function (e) {
    if (e.target.matches(ONETIME_SELECTOR)) {
      customerChoice = 'one-time';
      return;
    }
    if (e.target.matches(SUBSCRIPTION_INPUTS)) {
      customerChoice = 'subscription';
      selectedSellingPlan = e.target.value;
      return;
    }
    if (e.target.matches(SELLING_PLAN_SELECT)) {
      customerChoice = 'subscription';
      selectedSellingPlan = e.target.value;
      return;
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.subscription-toggle')) {
      customerChoice = 'subscription';
    }
    if (e.target.closest('label.single-payment')) {
      customerChoice = 'one-time';
    }
  });

  // Listen to variant radio changes
  document.querySelectorAll(VARIANT_RADIOS).forEach(function (radio) {
    radio.addEventListener('change', function () {
      restoreWithRetries();
    });
  });

  // Broad MutationObserver on the product form wrapper (survives re-renders)
  const formWrapper = document.querySelector('[data-product-form]')
    || document.querySelector('.form__wrapper')
    || document.querySelector('#productArea');

  if (formWrapper) {
    let debounceTimer;
    const observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        restoreChoice();
      }, 200);
    });
    observer.observe(formWrapper, { childList: true, subtree: true });
  }
})();